import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useTranslatedContent } from '../../i18n/hooks/useTranslatedContent';
import { COMPANY_CONTACT } from '../../constants/contact';

const FooterContact = () => {
  const { t } = useTranslatedContent('footer');

  return (
    <div>
      <h3 className="text-sm font-semibold uppercase tracking-[0.18em] text-white mb-4">{t('contact.title')}</h3>
      <ul className="space-y-3">
        <li className="flex items-center text-slate-400">
          <MapPin className="h-5 w-5 mr-2 text-cyan-300" />
          <span>
            {COMPANY_CONTACT.address.street}<br/>
            {COMPANY_CONTACT.address.postalCode} {COMPANY_CONTACT.address.city}<br/>
            {COMPANY_CONTACT.address.country}
          </span>
        </li>
        <li className="flex items-center text-slate-400">
          <Mail className="h-5 w-5 mr-2 text-cyan-300" />
          <a href={`mailto:${COMPANY_CONTACT.email}`} className="hover:text-white">
            {COMPANY_CONTACT.email}
          </a>
        </li>
        <li className="flex items-center text-slate-400">
          <Phone className="h-5 w-5 mr-2 text-cyan-300" />
          <a href={`tel:${COMPANY_CONTACT.phone.replace(/\s/g, '')}`} className="hover:text-white">
            {COMPANY_CONTACT.phone}
          </a>
        </li>
      </ul>
    </div>
  );
};

export default FooterContact;